<template>
    <a
        class="lds-widget-card"
        target="_blank"
        :href="offer.url"
        :class="offerClasses(offer.params.advantage)"
    >
        <ShowcaseOffersAdvantage
            v-if="uspPlacement === advantagesPlacement.OUTSIDE && offer.params.advantage"
            :advantage="offer.params.advantage.string"
        />
        <div class="lds-widget-card__wrapper">
            <ShowcaseOffersAdvantage
                v-if="uspPlacement === advantagesPlacement.INSIDE && offer.params.advantage"
                :advantage="offer.params.advantage.string"
            />
            <div class="lds-widget-card__row">
                <div class="lds-widget-card__container lds-widget-card__container_betting">
                    <div class="lds-widget-card__img">
                        <img
                            :src="offer.logoUrl"
                            :alt="offer.siteName"
                        >
                    </div>
                    <template v-if="offer.params.bettingDescription && (!isPlacementDesktopRow(desktopPlacement) || !isDesktop)">
                        <p class="lds-widget-card__name">
                            {{ offer.siteName }}
                        </p>
                        <p
                            class="lds-widget-card__item-betting"
                        >
                            {{ offer.params.bettingDescription.string }}
                        </p>
                    </template>
                    <div
                        v-if="isPlacementDesktopRow(desktopPlacement) && isDesktop"
                        class="lds-widget-card__heading"
                    >
                        <p class="lds-widget-card__name">
                            {{ offer.siteName }}
                        </p>
                        <p
                            v-if="offer.params.bettingDescription"
                            class="lds-widget-card__item-betting"
                        >
                            {{ offer.params.bettingDescription.string }}
                        </p>
                    </div>
                    <div class="lds-widget-card__params lds-widget-card__params_betting">
                        <div class="lds-widget-card__block lds-widget-card__block_betting">
                            <ShowcaseOfferParams
                                v-if="offer.params.bonusTo"
                                :name="offer.params.bonusTo.name"
                                :value="formatNumber(offer.params.bonusTo.string, false, 0)"
                                :class="['lds-widget-card__item_big', 'lds-widget-card__item_sum']"
                                :symbol="currencySymbol"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.ratingBetting"
                                :name="offer.params.ratingBetting.name"
                                :value="offer.params.ratingBetting.string"
                                class="lds-widget-card__item_rate"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params?.minDep && (isMobileTwoColumnsByWidth(containerWidth, mobilePlacement) || isPlacementDesktopRow(desktopPlacement) && isDesktop)"
                                name="мин. депозит"
                                :value="offer.params.minDep?.string"
                                class="lds-widget-card__item_period"
                                :symbol="currencySymbol"
                            />
                            <ShowcaseOfferParams
                                v-else
                                :name="offer.params.minDep?.name"
                                :value="offer.params.minDep?.string"
                                class="lds-widget-card__item_period"
                                :symbol="currencySymbol"
                            />
                        </div>
                    </div>
                </div>
                <span class="se-btn lds-widget-card__btn">{{ textBtn }}</span>
            </div>
        </div>
    </a>
</template>

<script setup>
import { inject } from 'vue';
import ShowcaseOffersAdvantage from '../ShowcaseOfferParams/ShowcaseOffersAdvantage.vue';
import ShowcaseOfferParams from '../ShowcaseOfferParams/ShowcaseOfferParams.vue';
import commonProps from '../../common/сommonProps.js';
import advantagesPlacement from '../../common/advantagesPlacement.js';
import {
    formatNumber,
    isMobileTwoColumnsByWidth,
    isPlacementDesktopRow,
} from '../../common/function.js';
// import { cookieStore } from '@/scripts/cookie.ts';
import showcaseOfferClasses from '../../common/showcaseOfferClasses.js';
import {useContainerWidth} from '../../../composables/useContainerWidth.js';


const props = defineProps({
    offer: {
        type: Object,
        required: true,
    },
    ...commonProps(),
});

const currencySymbol = inject('currencySymbol');
const { offerClasses } = showcaseOfferClasses(props);

function transformUrl(url) {
    return cookieStore.transformUrl(url);
}

// container queries
const widgetId = inject('widgetId');
const widgetType = inject('widgetType');
const widgetMode = inject('widgetMode');

const { containerWidth, isDesktop } = useContainerWidth(widgetId, widgetType, widgetMode);

</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>